<h1 mat-dialog-title i18n>Image to be replaced, {{getSizeString()}}</h1>
<div mat-dialog-content>
  <img [src]="getCurrentImageFromFile()[0].base64.toString()">
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close] cdkFocusInitial i18n>Ok</button>
</div>
